import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledAddSection = styled(FlexCenter)`
  cursor: pointer;
`;
